import React from "react";
import { arrayOf, shape, string } from "prop-types";
import BreadcrumbItem from "../../atoms/BreadcrumbItem";

import "./breadcrumb.m.css";

const Breadcrumb = ({ items, ...props }) => {
  return (
    <nav styleName="breadcrumb" {...props}>
      {items?.map((item, index) => (
        <React.Fragment key={index}>
          <BreadcrumbItem href={item?.href}>
            {item?.label}
          </BreadcrumbItem>
          {index < items.length - 1 && <BreadcrumbItem>/</BreadcrumbItem>}
        </React.Fragment>
      ))}
    </nav>
  );
};

Breadcrumb.propTypes = {
  items: arrayOf(shape({
    label: string.isRequired,
    href: string
  })).isRequired
};

export default Breadcrumb;